export default (name = 'master-card') => {
  const amex = { number: '9999 999999 99999', cvv: '9999' }
  const standard = { number: '9999 9999 9999 9999', cvv: '999' }

  return name === 'american-express' ? amex : standard
}
